
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 451.846 451.847"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"active-path",attrs:{"d":"M203.554 345.441L9.273 151.154c-12.365-12.359-12.365-32.397 0-44.75 12.354-12.354 32.391-12.354 44.744 0l171.909 171.914L397.829 106.41c12.359-12.354 32.394-12.354 44.748 0 12.359 12.354 12.359 32.391 0 44.75L248.293 345.446c-6.18 6.177-14.271 9.262-22.366 9.262-8.099 0-16.196-3.09-22.373-9.267z"}})])
          )
        }
      }
    